import type { Identity } from "@wb/ui/analytics/useIdentity";

export const identity: Identity = (_id) => {
  // NOTE: vercel analytics does not support identity
};
